import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import Timeline from 'src/components/timeline/list';
import { withRouter } from 'src/helpers';

/**
 * Shared Journey/Diary timeline panel.
 *
 * Props:
 *   model           {object}   required — a TreatmentsTimelineModel-compatible model
 *   loading         {bool}     optional external loading state (merged with internal)
 *   onReady         {fn}       called after listJourney succeeds (instead of default refreshRecent)
 *   onSelectJourney {fn}       override in-state selectJourney (e.g. route navigation)
 *   onJourneyUpdate {fn}       called on journeyUpdate event (in addition to forceUpdate)
 */
class JourneyTimeline extends BaseComponent {
  state = { loading: true };

  componentDidMount() {
    this.props.model.subscribe(this.subscription);
    this.props.model.on('journeyUpdate', this.onJourneyUpdate);
    this.props.model.on('accountSwitched', this.load);
    this.load();
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
    this.props.model.cancel('journeyUpdate', this.onJourneyUpdate);
    this.props.model.cancel('accountSwitched', this.load);
  }

  onJourneyUpdate = () => {
    this.props.onJourneyUpdate?.();
    this.forceUpdate();
  };

  load = () => {
    const { model, onReady } = this.props;
    this.setState({ loading: true });
    model.listJourney((err) => {
      if (!err) {
        if (onReady) {
          onReady();
        } else {
          model.setState({ journeyId: 'timeline' });
          model.refreshRecent();
        }
      }
      this.setState({ loading: false });
    });
  };

  selectJourney = (journey) => {
    const { model, onSelectJourney } = this.props;
    if (onSelectJourney) return onSelectJourney(journey);
    model.setState({ journeyId: journey.id, journey });
    model.refreshRecent();
  };

  render() {
    const { model, loading: externalLoading } = this.props;
    const { journeyId, journey, journeys } = model.state;
    const loading = this.state.loading || !!externalLoading;

    return (
      <Timeline
        loading={loading}
        forAll={false}
        model={model}
        journey={journey}
        journeyId={journeyId}
        journeys={journeys}
        selectJourney={this.selectJourney}
      />
    );
  }
}

export default withRouter(JourneyTimeline);

